/* Vestigium · visor de fotos del producto (SPEC5). CSS: vestigium.css §16.
   Reutiliza el modal del tema (snippets/product-media-modal.liquid + assets/product-modal.js), que sigue
   abriendo, cerrando con la X o Esc y atrapando el foco. En el móvil (MOVIL) el CSS lo convierte en una
   tira de fotos a pantalla completa y aquí se le añade:
   - abrir en la foto pulsada (product-modal.js centra el contenido y, en la tira, volvía a la 1),
   - contador «2 / 6» con aria-live,
   - doble toque: la foto ×2 en una capa que se mueve con el dedo (otro doble toque la cierra); el
     pellizco es el del navegador (touch-action lo deja pasar),
   - deslizar la foto hacia abajo para cerrar,
   - flechas del teclado (← →) y, con ratón (ventana estrecha o navegador ampliado), botones anterior/siguiente,
   - al cerrar, la galería de la página se queda en la última foto vista y la página no se mueve.
   En escritorio el modal es el del tema; solo se marca html.vg-visor-abierto (fuera grano y huella).
   No depende de secondary.js. Se carga con defer desde layout/theme.liquid, antes que product-modal.js:
   vigila el atributo «open» del <product-modal>, así que da igual el orden. */
(function () {
	'use strict';
	if (window.vgVisor) return;
	window.vgVisor = 1;

	var d = document, raiz = d.documentElement, P = { passive: true }, vv = window.visualViewport,
		MOVIL = matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse) and (max-height: 599px)'),
		abierto = null, yAntes = null, anchoAntes = innerWidth;
	function on(el, t, f, o) { el.addEventListener(t, f, o); }
	function quieto() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
	function pellizco() { return !!vv && vv.scale > 1.02; } // la página ampliada con dos dedos
	function cerca(a, b) { return Math.abs(a.x - b.x) < 40 && Math.abs(a.y - b.y) < 40; }

	// Fotos de la tira en orden (las ocultas, p. ej. de variante con «ocultar variantes», no cuentan)
	function fotos(m) { return Array.prototype.filter.call(m._vg.tira.children, function (n) { return n.offsetWidth > 0; }); }
	function enCurso(m) { var t = m._vg.tira, w = t.clientWidth; return w ? Math.round(t.scrollLeft / w) : 0; }

	// Contador, flechas y foto activa (.active, la que usa el tema) según lo que se ve
	function cuenta(m, forzar) {
		var v = m._vg, fs = fotos(m), n = fs.length, i = Math.min(enCurso(m), n - 1), f = fs[i];
		if (!f || (i === v.i && !forzar)) return;
		if (v.i >= 0 && i !== v.i) reduce(m); // otra foto: fuera el zoom de la anterior
		v.i = i;
		fs.forEach(function (x) { x.classList.toggle('active', x === f); });
		v.contador.hidden = v.ant.hidden = v.sig.hidden = n < 2;
		v.num.textContent = (i + 1) + ' / ' + n;
		di(m, 'Foto ' + (i + 1) + ' de ' + n);
		v.ant.setAttribute('aria-disabled', String(i === 0));
		v.sig.setAttribute('aria-disabled', String(i === n - 1));
		if (f.loading === 'lazy') f.loading = 'eager';
	}
	// Lo que oye el lector de pantalla. Al abrir, la región viva está vacía y acaba de dejar de estar
	// oculta (el modal cerrado lleva visibility: hidden): se rellena un poco después para que se
	// anuncie también la primera vez (una región que aparece ya con texto no se suele leer)
	function di(m, t) {
		var v = m._vg;
		clearTimeout(v.tVoz);
		if (!v.voz.textContent) v.tVoz = setTimeout(function () { if (abierto === m) v.voz.textContent = t; }, 300);
		else if (v.voz.textContent !== t) v.voz.textContent = t;
	}
	// Foto anterior (-1) o siguiente (1): flechas del teclado y botones para el ratón
	function paso(m, k) {
		var v = m._vg, i = Math.max(0, Math.min(fotos(m).length - 1, v.i + k));
		reduce(m);
		if (i !== v.i) v.tira.scrollTo({ left: i * v.tira.clientWidth, behavior: quieto() ? 'auto' : 'smooth' });
	}
	// Lleva la tira a la foto activa sin animación (al abrir, al girar el móvil…)
	function situa(m) {
		var v = m._vg, fs = fotos(m), i = Math.max(0, fs.indexOf(v.tira.querySelector(':scope > .active')));
		if (fs[i] && fs[i].loading === 'lazy') fs[i].loading = 'eager';
		v.tira.scrollLeft = i * v.tira.clientWidth;
		v.i = -1;
		cuenta(m, true);
	}

	// ---- Deslizar hacia abajo para cerrar ------------------------------------
	function baja(m, dy) {
		var f = m._vg.arrastrada;
		if (f) f.style.transform = 'translateY(' + Math.round(dy) + 'px) scale(' + (1 - Math.min(dy, 400) / 1600).toFixed(3) + ')';
		m.style.setProperty('--vg-visor-alfa', (1 - Math.min(dy, 320) / 450).toFixed(3));
	}
	function suelta(m) {
		var v = m._vg, f = v && v.arrastrada;
		m.classList.remove('is-vg-bajando');
		m.style.removeProperty('--vg-visor-alfa');
		if (!f) return;
		v.arrastrada = null;
		f.style.transition = quieto() || !m.hasAttribute('open') ? '' : 'transform .25s cubic-bezier(.2,.7,.2,1)';
		f.style.transform = '';
		setTimeout(function () { f.style.transition = ''; }, 260);
	}

	// ---- Doble toque: ×2 en una capa aparte con scroll nativo -----------------
	function amplia(m, x, y) {
		var v = m._vg, f = fotos(m)[v.i], lupa = v.lupa, im = v.lupaImg, r, nw, nh, k, w, h, px, py, lr, pre;
		if (!f || f.tagName !== 'IMG') return;
		r = f.getBoundingClientRect();
		nw = f.naturalWidth || +f.getAttribute('width') || r.width;
		nh = f.naturalHeight || +f.getAttribute('height') || r.height;
		k = Math.min(r.width / nw, r.height / nh); // tamaño de la foto ya ajustada (object-fit: contain)
		w = nw * k;
		h = nh * k;
		px = Math.min(1, Math.max(0, (x - r.left - (r.width - w) / 2) / w));
		py = Math.min(1, Math.max(0, (y - r.top - (r.height - h) / 2) / h));
		im.src = f.currentSrc || f.src;
		im.style.width = Math.round(w * 2) + 'px';
		im.style.height = Math.round(h * 2) + 'px';
		m.classList.add('is-vg-ampliada');
		// El punto tocado se queda bajo el dedo
		lr = lupa.getBoundingClientRect();
		lupa.scrollLeft = Math.max(0, (lr.width - w * 2) / 2) + px * w * 2 - (x - lr.left);
		lupa.scrollTop = Math.max(0, (lr.height - h * 2) / 2) + py * h * 2 - (y - lr.top);
		if (!quieto() && im.animate) {
			im.style.transformOrigin = (px * 100).toFixed(1) + '% ' + (py * 100).toFixed(1) + '%';
			im.animate([{ transform: 'scale(.5)' }, { transform: 'none' }], { duration: 240, easing: 'cubic-bezier(.2,.7,.2,1)' });
		}
		// Más resolución para la foto ampliada (el srcset del tema llega a 2890 y 4096 px)
		v.pre = null;
		if (f.srcset) {
			pre = new Image();
			pre.decoding = 'async';
			pre.sizes = Math.round(w * 2) + 'px';
			pre.srcset = f.srcset;
			v.pre = pre;
			pre.onload = function () { if (v.pre === pre && m.classList.contains('is-vg-ampliada')) im.src = pre.currentSrc || pre.src; };
		}
	}
	function reduce(m) {
		var v = m._vg;
		if (!v || !m.classList.contains('is-vg-ampliada')) return;
		m.classList.remove('is-vg-ampliada');
		v.pre = null;
		v.lupaImg.removeAttribute('src');
	}

	// ---- Gestos con el dedo (el ratón lo sigue llevando el tema) --------------
	function gestos(m) {
		var v = m._vg, t = v.tira, g = null, toque = null, l = null, lt = null;
		on(t, 'pointerdown', function (e) {
			if (e.pointerType === 'mouse' || !MOVIL.matches) return;
			if (g) { // segundo dedo: es un pellizco, lo hace el navegador
				if (g.baja) suelta(m);
				g = toque = null;
				return;
			}
			g = { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.timeStamp, dy: 0 };
		}, P);
		on(t, 'pointermove', function (e) {
			if (!g || e.pointerId !== g.id) return;
			var dx = e.clientX - g.x, dy = e.clientY - g.y;
			if (!g.baja) {
				if (dx * dx + dy * dy > 100) g.movio = 1;
				// Hacia abajo y más vertical que horizontal (en horizontal desliza la tira el navegador)
				if (dy < 14 || dy < Math.abs(dx) * 1.4 || pellizco()) return;
				g.baja = 1;
				v.arrastrada = fotos(m)[v.i];
				m.classList.add('is-vg-bajando');
			}
			g.dy = Math.max(0, dy);
			baja(m, g.dy);
		}, P);
		on(t, 'pointerup', function (e) {
			if (!g || e.pointerId !== g.id) return;
			var x = g, ms = e.timeStamp - g.t, p = { x: e.clientX, y: e.clientY, t: e.timeStamp };
			g = null;
			if (x.baja) {
				toque = null;
				if (x.dy > 110 || (x.dy > 40 && x.dy / Math.max(1, ms) > 0.6)) m.hide();
				else suelta(m);
				return;
			}
			if (x.movio || ms > 350) { toque = null; return; }
			if (toque && p.t - toque.t < 330 && cerca(p, toque)) {
				toque = null;
				amplia(m, p.x, p.y);
			} else toque = p;
		}, P);
		on(t, 'pointercancel', function (e) {
			if (g && e.pointerId === g.id && g.baja) suelta(m);
			g = toque = null;
		}, P);
		// En la capa ampliada: otro doble toque la cierra (al moverla con el dedo llega pointercancel)
		on(v.lupa, 'pointerdown', function (e) { l = { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.timeStamp }; }, P);
		on(v.lupa, 'pointercancel', function () { l = lt = null; }, P);
		on(v.lupa, 'pointerup', function (e) {
			var x = l, p = { x: e.clientX, y: e.clientY, t: e.timeStamp };
			l = null;
			if (!x || x.id !== e.pointerId || Math.abs(p.x - x.x) > 10 || Math.abs(p.y - x.y) > 10 || p.t - x.t > 350) { lt = null; return; }
			if (lt && p.t - lt.t < 330 && cerca(p, lt)) {
				lt = null;
				reduce(m);
			} else lt = p;
		}, P);
	}

	// Botón anterior/siguiente (solo se ve con ratón: CSS)
	function flecha(m, k, nombre, trazo) {
		var b = d.createElement('button');
		b.type = 'button';
		b.className = 'vg-visor__flecha vg-visor__flecha--' + (k < 0 ? 'ant' : 'sig');
		b.setAttribute('aria-label', nombre);
		b.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20"><path d="' + trazo + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		on(b, 'pointerup', function (e) { e.stopPropagation(); }); // el tema cierra el visor con cualquier pointerup del ratón
		on(b, 'click', function () { if (b.getAttribute('aria-disabled') !== 'true') paso(m, k); });
		return b;
	}

	// Contador, flechas y capa de zoom, una vez por modal (dentro del diálogo: el foco atrapado y
	// aria-modal los incluyen). El tema atrapa el foco entre el primer y el último enfocable del
	// diálogo (la X y la tira, con el selector de getFocusableElements, que cuenta hasta [draggable]):
	// las flechas van antes de la tira y nada enfocable va después
	function preparar(m) {
		if (m._vg) return m._vg;
		var dlg = m.querySelector('[role="dialog"]'), tira = m.querySelector('.product-media-modal__content'), v, raf = 0;
		if (!dlg || !tira) return null;
		v = m._vg = { tira: tira, i: -1 };
		v.lupa = d.createElement('div');
		v.lupa.className = 'vg-visor__lupa';
		v.lupa.setAttribute('aria-hidden', 'true');
		v.lupa.tabIndex = -1;
		v.lupa.innerHTML = '<img alt="" decoding="async">';
		v.lupaImg = v.lupa.firstChild;
		v.contador = d.createElement('p');
		v.contador.className = 'vg-visor__contador';
		v.contador.setAttribute('aria-live', 'polite');
		v.contador.setAttribute('aria-atomic', 'true');
		v.contador.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
		v.num = v.contador.firstChild;
		v.voz = v.contador.lastChild;
		v.ant = flecha(m, -1, 'Foto anterior', 'M15 5l-7 7 7 7');
		v.sig = flecha(m, 1, 'Foto siguiente', 'M9 5l7 7-7 7');
		dlg.insertBefore(v.ant, tira);
		dlg.insertBefore(v.sig, tira);
		dlg.appendChild(v.lupa);
		dlg.appendChild(v.contador);
		on(tira, 'scroll', function () {
			raf = raf || requestAnimationFrame(function () { raf = 0; if (abierto === m && MOVIL.matches) cuenta(m); });
		}, P);
		// ← → con el foco en el diálogo (donde lo deja el tema al abrir), la X o las flechas; en la
		// tira ya lo hace el navegador. Con Alt/Ctrl/Cmd no: Alt+← es «atrás»
		on(m, 'keydown', function (e) {
			var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
			if (!k || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || abierto !== m || !MOVIL.matches || tira.contains(e.target)) return;
			e.preventDefault();
			paso(m, k);
		});
		gestos(m);
		return v;
	}

	function abrir(m) {
		var y = yAntes;
		yAntes = null;
		abierto = m;
		m._vgAbierto = 1;
		raiz.classList.add('vg-visor-abierto');
		// product-modal.js hace scrollIntoView de la foto: la página no debe moverse por debajo
		if (y != null && Math.abs(scrollY - y) > 1) scrollTo(scrollX, y);
		m._vgY = y != null ? y : scrollY;
		if (!MOVIL.matches || !preparar(m)) return;
		m.classList.toggle('is-vg-pellizco', pellizco());
		situa(m);
	}
	function cerrar(m) {
		m._vgAbierto = 0;
		if (abierto === m) abierto = null;
		if (!d.querySelector('product-modal[open]')) raiz.classList.remove('vg-visor-abierto');
		if (m._vg) {
			reduce(m);
			suelta(m);
			m.classList.remove('is-vg-pellizco');
			clearTimeout(m._vg.tVoz);
			m._vg.voz.textContent = ''; // vacía para la próxima vez (ver di)
		}
		if (m._vgY != null && Math.abs(scrollY - m._vgY) > 1) scrollTo(scrollX, m._vgY);
	}

	// El tema avisa con «modalClosed» justo antes de devolver el foco (removeTrapFocus(openedBy)): en el
	// móvil, la galería pasa a la última foto vista y el foco vuelve a esa foto, sin mover la página
	function alCerrar() {
		var m = abierto, v = m && m._vg, f, id, b, otra, item, gal;
		if (!v || !MOVIL.matches || v.i < 0) return;
		f = fotos(m)[v.i];
		id = f && f.getAttribute('data-media-id');
		b = id && m.id && d.querySelector('modal-opener[data-modal="#' + m.id + '"] button[data-media-id="' + id + '"]');
		if (!b) return; // foto que no está en la galería (la portada solo enseña la principal): el foco vuelve a la pulsada
		otra = b !== m.openedBy;
		m.openedBy = b;
		// Con el foco ya puesto sin desplazar, el focus() del tema no mueve nada
		try { b.focus({ preventScroll: true }); } catch (e) { /* nada */ }
		if (!otra) return;
		item = b.closest('[data-media-id]:not(button)');
		gal = b.closest('media-gallery');
		try { if (item && gal && gal.setActiveMedia) gal.setActiveMedia(item.getAttribute('data-media-id'), false); } catch (e) { /* nada */ }
	}

	var mo = window.MutationObserver && new MutationObserver(function (rs) {
		rs.forEach(function (r) {
			var m = r.target;
			try {
				if (m.hasAttribute('open')) { if (!m._vgAbierto) abrir(m); }
				else if (m._vgAbierto) cerrar(m);
			} catch (e) { /* un fallo aquí no debe dejar el modal a medias */ }
		});
	});
	function vigila() {
		if (!mo) return;
		Array.prototype.forEach.call(d.querySelectorAll('product-modal'), function (m) {
			if (m._vgVigilado) return;
			m._vgVigilado = 1;
			mo.observe(m, { attributes: true, attributeFilter: ['open'] });
		});
	}

	// La posición de la página justo antes de abrir (antes del scrollIntoView del tema)
	on(d, 'click', function (e) {
		if (!e.target.closest || !e.target.closest('modal-opener button')) return;
		yAntes = scrollY;
		vigila();
	}, true);
	function iniciar() {
		vigila();
		if (d.body) on(d.body, 'modalClosed', alCerrar);
	}
	if (d.readyState === 'loading') on(d, 'DOMContentLoaded', iniciar);
	else iniciar();
	on(d, 'shopify:section:load', vigila);

	// Pellizco del navegador: con la página ampliada la tira deja mover en vertical (y no se cierra al bajar)
	if (vv) on(vv, 'resize', function () { if (abierto && abierto._vg) abierto.classList.toggle('is-vg-pellizco', pellizco()); }, P);
	// Girar el móvil o cambiar de tamaño: la tira sigue en la misma foto y se quita el zoom
	function recoloca() {
		var m = abierto;
		if (!m) return;
		if (MOVIL.matches && preparar(m)) situa(m);
		else if (m._vg) { reduce(m); suelta(m); }
	}
	if (MOVIL.addEventListener) MOVIL.addEventListener('change', recoloca);
	else if (MOVIL.addListener) MOVIL.addListener(recoloca);
	on(window, 'resize', function () {
		if (innerWidth === anchoAntes) return; // la barra del navegador que entra y sale no cuenta
		anchoAntes = innerWidth;
		if (abierto && abierto._vg) reduce(abierto);
		recoloca();
	}, P);
})();
